export class AttendeeDto {
  email: string
  name: string

  constructor(params?: { email: string; name: string }) {
    if (params) {
      this.email = params.email != null ? params.email : null
      this.name = params.name != null ? params.name : null
    }
  }
}

export class AttendeeModel {
  id: string
  email: string
  name: string
  validatedAt?: number
  eventId?: string
  eventName?: string

  constructor(params?: {
    id: string
    email: string
    name: string
    validatedAt?: number
    eventId?: string
    eventName?: string
  }) {
    if (params) {
      this.id = params.id != null ? params.id : ''
      this.email = params.email != null ? params.email : ''
      this.name = params.name != null ? params.name : ''
      if (params.validatedAt !== undefined) {
        this.validatedAt = params.validatedAt
      }
      if (params.eventId !== undefined) {
        this.eventId = params.eventId
      }
      if (params.eventName !== undefined) {
        this.eventName = params.eventName
      }
    }
  }
}
